import React, { useState, useEffect } from 'react';
import {
    TableToolbar,
    TableToolbarContent,
    TableToolbarMenu,
    TableToolbarSearch,
    Checkbox,
    Button
} from 'carbon-components-react';
import { FilterEdit32 } from '@carbon/icons-react';

import Filters from './Alerts/Filters';
import DashboardTable from '../Dashboards/DashboardTable';
import TableToolbarDownload from 'common/TableToolbarDownload';
import * as DashboardConstants from '../Dashboards/DashboardConstants';

export default function ResourceIssuesTable(props) {

    const [showFilters, setShowFilters] = useState(false);
    const [filteredTableHeaders, setFilteredTableHeaders] = useState([]);
    const [searchedResourceData, setSearchedResourceData] = useState([]);
    const [searchedValue, setSearchedValue] = useState('');
    const [resourceDataLoading, setResourceDataLoading] = useState(props.ResourceDataLoading);

    useEffect(()=>{
        setResourceDataLoading(props.ResourceDataLoading)
    },[props.ResourceDataLoading])

    const manageHeader = (checked, id) => {
        props.headers.forEach(header => {
            if (header.key === id) {
                header.hidden = !checked;
            }
        });
        let filteredheader = props.headers.filter(header => header.hidden === false);
        setFilteredTableHeaders(filteredheader);
    };

    const searchTable = (event) => {
        let searchString = event.target.value.toUpperCase();
        let newList = [];
        let string, pattern;
        let matchedStrings;
        if (searchString) {
            newList = props.rows.filter((element) => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        if (element[property] && property !== "id") {
                            string = element[property];
                        }
                        else string = '';
                        string = string ? string.toString() : "";
                        pattern = new RegExp("(\\w*" + searchString + "\\w*)", "gi");
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            newList = newList.concat([element]);
                            return newList;
                        }
                    }
                }
            });
            setSearchedResourceData(newList);

        } else {
            setSearchedResourceData([]);
        }
    };

    const handleFilters = () => {
        setShowFilters(!showFilters);
    };

    const handleClose = () => {
        setShowFilters(!showFilters);
    }



    return (
        <div>
            <TableToolbar aria-label="data table toolbar">
                <TableToolbarContent style={{ clipPath: 'none', zIndex: 1 }}>
                    <TableToolbarSearch onChange={(e) => { setSearchedValue(e.target.value); searchTable(e) }} className="search-button" />
                    <TableToolbarMenu light iconDescription="Headers">
                        <fieldset className="optional-headers">
                            {props.headers.map(header => (header.optional ? <Checkbox labelText={header.header} checked={!header.hidden} onChange={manageHeader} id={header.key} /> : null))}
                        </fieldset>
                    </TableToolbarMenu>
                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={props.downloadRows} headers={props.headers} title={props.title} filename={`${DashboardConstants.ResourceStatus} ${props.title}`} label={DashboardConstants.Download} />
                    <Button onClick={handleFilters} renderIcon={FilterEdit32}>{DashboardConstants.Filters}</Button>
                </TableToolbarContent>
            </TableToolbar>
            {showFilters ?
                <div>
                    <Filters workspace={props.workspace} alertType={props.alertType} filterData={props.filterData} filterSelections={props.filterSelections} status={props.status}
                        disabledSelects={props.disabledSelects} handleClose={handleClose} fetchAlertsData={props.fetchAlertsData} updateState={props.updateState} isResourceType={props.isResourceType}
                        isQueueType={false}
                    />
                </div> : null
            }
            <DashboardTable
                headers={filteredTableHeaders.length ? filteredTableHeaders : props.headers.filter(header => header.hidden === false)}
                rows={searchedValue.length ? searchedResourceData : props.rows}
                showPagination={true}
                isSortingAllowed={true}
                loading={resourceDataLoading}
                defaultCurrentPageSize={10}
            />
        </div>
    )
}